var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{staticClass:"d-flex flex-grow-1 pa-0"})
}
var staticRenderFns = []

export { render, staticRenderFns }